(function () {
  'use strict';

  angular.module('ringbaPortal').component('availableTargetGroups', {
    bindings: {
      routeContainerType: '<', // either campaign or callplan
      routeContainer: '<',
      routeContainerRoutes: '<',
      onUpdate: '&',
      isRpc: '<'
    },
    controller: AvailableTargetGroupsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/available-target-groups.view.html'
  });

  function AvailableTargetGroupsController(
    $filter,
    $scope,
    $uibModal,
    $timeout,
    accountsService,
    campaignServiceNew,
    callPlanService,
    callRouteService,
    targetGroupService,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.currentRoute = {};
    vm.isRefreshingTargetGroups = false;

    vm.$onChanges = onChanges;
    vm.cancelModal = cancelModal;
    vm.createNewRoute = createNewRoute;
    vm.newTargetGroupRoute = newTargetGroupRoute;
    vm.newTargetGroup = newTargetGroup;
    vm.onSave = onSave;
    vm.addRouteToCampaignOrCallPlan = addRouteToCampaignOrCallPlan;
    vm.refreshTargetGroups = refreshTargetGroups;

    function onChanges(changesObj) {
      if (changesObj.routeContainerRoutes) {
        if (changesObj.routeContainerRoutes.isFirstChange()) {
          vm.loading = true;
        }
        _loadTargetGroups();
      }
    }

    function cancelModal() {
      vm.currentRoute = undefined;
      vm.modal.close();
      vm.modal = null;
    }

    function createNewRoute() {
      vm.currentRoute.targetGroupId = vm.selectedTargetGroup.id;
      vm.currentRoute.callTargetGroup = vm.selectedTargetGroup;
      return addRouteToCampaignOrCallPlan(vm.currentRoute).then(function () {
        cancelModal();
        vm.onUpdate({
          routeContainer: vm.routeContainer
        });
      }).catch(utils.errorHandler);
    }

    function newTargetGroup() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-target-group.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl'
      });
    }

    function newTargetGroupRoute(callGroup) {
      vm.selectedTargetGroup = callGroup;
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/new-target-group-route.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'xl',
        resolve: {
          propsData: function () {
            return {
              isRpc: vm.isRpc,
            };
          }
        }
      });
    }

    function onSave() {
      cancelModal();
      vm.onUpdate({
        routeContainer: vm.routeContainer
      });
    }

    function addRouteToCampaignOrCallPlan(route) {
      if (vm.routeContainerType === 'callPlan') {
        return callRouteService.createCallRoute(accountsService.currentAccountId, route).then(function (response) {
          return callPlanService.addRoute(accountsService.currentAccountId, vm.routeContainer.id, response.data.callRoute.id);
        });
      } else {
        return campaignServiceNew.addRoute(
          accountsService.currentAccountId,
          vm.routeContainer.id,
          route
        );
      }
    }

    function _loadTargetGroups() {
      targetGroupService.getTargetGroups(accountsService.currentAccountId)
        .then(function (response) {
          if (response && response.data && response.data.targetGroups && response.data.targetGroups.length > 0) {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_ALL_TARGET_GROUPS_ASSIGNED');
          } else {
            vm.noTargetAvailableMessage = $filter('translate')('CAMPAIGN_STEP_ROUTING_NONE_TARGET_GROUPS');
          }
          vm.targetGroups = $filter('notInCampaignRoutes')(response.data.targetGroups, vm.routeContainerRoutes, 'group');
          vm.loading = false;
        })
        .catch(utils.errorHandler);
    }

    function refreshTargetGroups() {
      vm.isRefreshingTargetGroups = true;
      try {
        _loadTargetGroups();
      } finally {
        $timeout(() => {
          vm.isRefreshingTargetGroups = false;
        }, 600);
      }
    }
  }
})();
